import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppliancesApiService } from '@common/data-access-appliance-details';
import { ErrorService } from '@common/util-foundation';
import { Appliance } from '@common/util-models';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import * as AppliancesActions from './appliances.actions';

@Injectable()
export class AppliancesEffects {
  loadAppliances$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AppliancesActions.loadAppliances),
      switchMap(() =>
        this.appliancesService.getAppliances().pipe(
          map((appliances: Appliance[]) =>
            AppliancesActions.loadAppliancesSuccess({
              appliances,
            })
          ),
          catchError((error: HttpErrorResponse) => {
            this.handleError();
            return of(AppliancesActions.loadAppliancesFailure({ error }));
          })
        )
      )
    )
  );

  handleError() {
    this.errorService.handleError();
  }

  constructor(
    private actions$: Actions,
    private appliancesService: AppliancesApiService,
    private errorService: ErrorService
  ) {}
}
